/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CreditFacilityData
} from '../../model/creditFacilityData'
import type {
  CreditFacilityDataList
} from '../../model/creditFacilityDataList'
import type {
  CreditFacilityEditDataRequest
} from '../../model/creditFacilityEditDataRequest'
import type {
  CreditFacilityEditParams
} from '../../model/creditFacilityEditParams'
import type {
  CreditFacilityExpenseAdjustments
} from '../../model/creditFacilityExpenseAdjustments'
import type {
  CreditFacilityExpenseAdjustmentsUpdateDataRequest
} from '../../model/creditFacilityExpenseAdjustmentsUpdateDataRequest'
import type {
  CreditFacilityExpenseEventPeriodRetrieveParams
} from '../../model/creditFacilityExpenseEventPeriodRetrieveParams'
import type {
  CreditFacilityExpenseEventReadData
} from '../../model/creditFacilityExpenseEventReadData'
import type {
  CreditFacilityExpenseEventUpsertDataRequest
} from '../../model/creditFacilityExpenseEventUpsertDataRequest'
import type {
  CreditFacilityExpenseSummaryData
} from '../../model/creditFacilityExpenseSummaryData'
import type {
  CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams
} from '../../model/creditFacilityInterestExpenseAdjustmentsTableRetrieveParams'
import type {
  CreditFacilityLoanCreateDataRequest
} from '../../model/creditFacilityLoanCreateDataRequest'
import type {
  CreditFacilityLoanData
} from '../../model/creditFacilityLoanData'
import type {
  CreditFacilityLoanEditAPIDataRequest
} from '../../model/creditFacilityLoanEditAPIDataRequest'
import type {
  CreditFacilityLoanVersionReadData
} from '../../model/creditFacilityLoanVersionReadData'
import type {
  CreditFacilityLoanVersionRetrieveParams
} from '../../model/creditFacilityLoanVersionRetrieveParams'
import type {
  CreditFacilityMergeTranchesUpsertDataRequest
} from '../../model/creditFacilityMergeTranchesUpsertDataRequest'
import type {
  CreditFacilityPaydownTrancheDetailsDataRequest
} from '../../model/creditFacilityPaydownTrancheDetailsDataRequest'
import type {
  CreditFacilityPaydownUpsertDataRequest
} from '../../model/creditFacilityPaydownUpsertDataRequest'
import type {
  CreditFacilityPrincipalSummaryData
} from '../../model/creditFacilityPrincipalSummaryData'
import type {
  CreditFacilityPrincipalUseReallocationDataRequest
} from '../../model/creditFacilityPrincipalUseReallocationDataRequest'
import type {
  CreditFacilityPrincipalUsesRetrieveParams
} from '../../model/creditFacilityPrincipalUsesRetrieveParams'
import type {
  CreditFacilityReallocationDataRetrieveParams
} from '../../model/creditFacilityReallocationDataRetrieveParams'
import type {
  CreditFacilityReallocationReadData
} from '../../model/creditFacilityReallocationReadData'
import type {
  CreditFacilityReallocationResponseData
} from '../../model/creditFacilityReallocationResponseData'
import type {
  CreditFacilitySummaryRetrieveParams
} from '../../model/creditFacilitySummaryRetrieveParams'
import type {
  CreditFacilityTranchesAvailableForPostingList
} from '../../model/creditFacilityTranchesAvailableForPostingList'
import type {
  CreditFacilityUpsertDataRequest
} from '../../model/creditFacilityUpsertDataRequest'
import type {
  CreditFacilityVersionData
} from '../../model/creditFacilityVersionData'
import type {
  CreditFacilityVersionRetrieveParams
} from '../../model/creditFacilityVersionRetrieveParams'
import type {
  CreditFacilityVersionUpsertDataRequest
} from '../../model/creditFacilityVersionUpsertDataRequest'
import type {
  DrawdownResponseData
} from '../../model/drawdownResponseData'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  FundFamilyUseAllocationTableDataRequest
} from '../../model/fundFamilyUseAllocationTableDataRequest'
import type {
  FundFamilyUseAllocationTableDataWithDefinition
} from '../../model/fundFamilyUseAllocationTableDataWithDefinition'
import type {
  GenericChartData
} from '../../model/genericChartData'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  GenericTableDataList
} from '../../model/genericTableDataList'
import type {
  InterestExpensePeriodData
} from '../../model/interestExpensePeriodData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Lists credit facilities for a fund family.
 */
export const creditFacilityList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityDataList>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/`] as const;
    }

    
export const getCreditFacilityListQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityList>>> = ({ signal }) => creditFacilityList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityListQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityList>>>
export type CreditFacilityListQueryError = unknown

export const useCreditFacilityList = <TData = Awaited<ReturnType<typeof creditFacilityList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityList>>> = ({ signal }) => creditFacilityList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityList>>>
export type CreditFacilityListSuspenseQueryError = unknown

export const useCreditFacilityListSuspense = <TData = Awaited<ReturnType<typeof creditFacilityList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityListQueryKey(fundFamilyId),
              queryFn: () => creditFacilityList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts a credit facility.
 */
export const creditFacilityUpsert = (
    fundFamilyId: string,
    creditFacilityUpsertDataRequest: CreditFacilityUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityUpsertDataRequest
    },
      options);
    }
  


export const getCreditFacilityUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityUpsert>>, TError,{fundFamilyId: string;data: CreditFacilityUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityUpsert>>, TError,{fundFamilyId: string;data: CreditFacilityUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityUpsert>>, {fundFamilyId: string;data: CreditFacilityUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  creditFacilityUpsert(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityUpsert>>>
    export type CreditFacilityUpsertMutationBody = CreditFacilityUpsertDataRequest
    export type CreditFacilityUpsertMutationError = unknown

    export const useCreditFacilityUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityUpsert>>, TError,{fundFamilyId: string;data: CreditFacilityUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets a credit facility by id.
 */
export const creditFacilityRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/`] as const;
    }

    
export const getCreditFacilityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityRetrieve>>> = ({ signal }) => creditFacilityRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityRetrieve>>>
export type CreditFacilityRetrieveQueryError = unknown

export const useCreditFacilityRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityRetrieveQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityRetrieve>>> = ({ signal }) => creditFacilityRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityRetrieve>>>
export type CreditFacilityRetrieveSuspenseQueryError = unknown

export const useCreditFacilityRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityRetrieveQueryKey(fundFamilyId,creditFacilityId),
              queryFn: () => creditFacilityRetrieve(fundFamilyId,creditFacilityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edits a credit facility when in an active state.
 */
export const creditFacilityEdit = (
    fundFamilyId: string,
    creditFacilityId: string,
    creditFacilityEditDataRequest: CreditFacilityEditDataRequest,
    params?: CreditFacilityEditParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityEditDataRequest,
        params
    },
      options);
    }
  


export const getCreditFacilityEditMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityEditDataRequest;params?: CreditFacilityEditParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityEditDataRequest;params?: CreditFacilityEditParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityEdit>>, {fundFamilyId: string;creditFacilityId: string;data: CreditFacilityEditDataRequest;params?: CreditFacilityEditParams}> = (props) => {
          const {fundFamilyId,creditFacilityId,data,params} = props ?? {};

          return  creditFacilityEdit(fundFamilyId,creditFacilityId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityEditMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityEdit>>>
    export type CreditFacilityEditMutationBody = CreditFacilityEditDataRequest
    export type CreditFacilityEditMutationError = unknown

    export const useCreditFacilityEdit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityEditDataRequest;params?: CreditFacilityEditParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityEditMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a credit facility
 */
export const creditFacilityDelete = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getCreditFacilityDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityDelete>>, TError,{fundFamilyId: string;creditFacilityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityDelete>>, TError,{fundFamilyId: string;creditFacilityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityDelete>>, {fundFamilyId: string;creditFacilityId: string}> = (props) => {
          const {fundFamilyId,creditFacilityId} = props ?? {};

          return  creditFacilityDelete(fundFamilyId,creditFacilityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityDelete>>>
    
    export type CreditFacilityDeleteMutationError = unknown

    export const useCreditFacilityDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityDelete>>, TError,{fundFamilyId: string;creditFacilityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a drawdown for a credit facility
 */
export const creditFacilityDrawdownRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyUseAllocationTableDataWithDefinition>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/drawdown/`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityDrawdownRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/drawdown/`] as const;
    }

    
export const getCreditFacilityDrawdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityDrawdownRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>> = ({ signal }) => creditFacilityDrawdownRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityDrawdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>>
export type CreditFacilityDrawdownRetrieveQueryError = unknown

export const useCreditFacilityDrawdownRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityDrawdownRetrieveQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityDrawdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityDrawdownRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>> = ({ signal }) => creditFacilityDrawdownRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityDrawdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>>
export type CreditFacilityDrawdownRetrieveSuspenseQueryError = unknown

export const useCreditFacilityDrawdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityDrawdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityDrawdownRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityDrawdownRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityDrawdownRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId),
              queryFn: () => creditFacilityDrawdownRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a drawdown for a credit facility
 */
export const creditFacilityDrawdownCreate = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    fundFamilyUseAllocationTableDataRequest: FundFamilyUseAllocationTableDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<DrawdownResponseData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/drawdown/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyUseAllocationTableDataRequest
    },
      options);
    }
  


export const getCreditFacilityDrawdownCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityDrawdownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityDrawdownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityDrawdownCreate>>, {fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,fundFamilyEventId,data} = props ?? {};

          return  creditFacilityDrawdownCreate(fundFamilyId,creditFacilityId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityDrawdownCreateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityDrawdownCreate>>>
    export type CreditFacilityDrawdownCreateMutationBody = FundFamilyUseAllocationTableDataRequest
    export type CreditFacilityDrawdownCreateMutationError = unknown

    export const useCreditFacilityDrawdownCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityDrawdownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityDrawdownCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get selectable credit facility principal tranches for a merge event
 */
export const creditFacilityMergePrincipalTranchesRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/merge`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityMergePrincipalTranchesRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/merge`] as const;
    }

    
export const getCreditFacilityMergePrincipalTranchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityMergePrincipalTranchesRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>> = ({ signal }) => creditFacilityMergePrincipalTranchesRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityMergePrincipalTranchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>>
export type CreditFacilityMergePrincipalTranchesRetrieveQueryError = unknown

export const useCreditFacilityMergePrincipalTranchesRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityMergePrincipalTranchesRetrieveQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityMergePrincipalTranchesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityMergePrincipalTranchesRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>> = ({ signal }) => creditFacilityMergePrincipalTranchesRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityMergePrincipalTranchesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>>
export type CreditFacilityMergePrincipalTranchesRetrieveSuspenseQueryError = unknown

export const useCreditFacilityMergePrincipalTranchesRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityMergePrincipalTranchesRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityMergePrincipalTranchesRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityMergePrincipalTranchesRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId),
              queryFn: () => creditFacilityMergePrincipalTranchesRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Merges selected credit facility principal tranches
 */
export const creditFacilityMergePrincipalTranchesCreate = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    creditFacilityMergeTranchesUpsertDataRequest: CreditFacilityMergeTranchesUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/merge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityMergeTranchesUpsertDataRequest
    },
      options);
    }
  


export const getCreditFacilityMergePrincipalTranchesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityMergeTranchesUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityMergeTranchesUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesCreate>>, {fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityMergeTranchesUpsertDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,fundFamilyEventId,data} = props ?? {};

          return  creditFacilityMergePrincipalTranchesCreate(fundFamilyId,creditFacilityId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityMergePrincipalTranchesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesCreate>>>
    export type CreditFacilityMergePrincipalTranchesCreateMutationBody = CreditFacilityMergeTranchesUpsertDataRequest
    export type CreditFacilityMergePrincipalTranchesCreateMutationError = unknown

    export const useCreditFacilityMergePrincipalTranchesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityMergeTranchesUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityMergePrincipalTranchesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieves the paydown table for a credit facility.
 */
export const creditFacilityPaydownTableRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyUseAllocationTableDataWithDefinition>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/paydown/`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityPaydownTableRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/paydown/`] as const;
    }

    
export const getCreditFacilityPaydownTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityPaydownTableRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>> = ({ signal }) => creditFacilityPaydownTableRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityPaydownTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>>
export type CreditFacilityPaydownTableRetrieveQueryError = unknown

export const useCreditFacilityPaydownTableRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityPaydownTableRetrieveQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityPaydownTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityPaydownTableRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>> = ({ signal }) => creditFacilityPaydownTableRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityPaydownTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>>
export type CreditFacilityPaydownTableRetrieveSuspenseQueryError = unknown

export const useCreditFacilityPaydownTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityPaydownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityPaydownTableRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityPaydownTableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityPaydownTableRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId),
              queryFn: () => creditFacilityPaydownTableRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a credit facility paydown.
 */
export const creditFacilityPaydownCreate = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    fundFamilyUseAllocationTableDataRequest: FundFamilyUseAllocationTableDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/paydown/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyUseAllocationTableDataRequest
    },
      options);
    }
  


export const getCreditFacilityPaydownCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityPaydownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityPaydownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityPaydownCreate>>, {fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,fundFamilyEventId,data} = props ?? {};

          return  creditFacilityPaydownCreate(fundFamilyId,creditFacilityId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityPaydownCreateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityPaydownCreate>>>
    export type CreditFacilityPaydownCreateMutationBody = FundFamilyUseAllocationTableDataRequest
    export type CreditFacilityPaydownCreateMutationError = unknown

    export const useCreditFacilityPaydownCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityPaydownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: FundFamilyUseAllocationTableDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityPaydownCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieve a paydown for a credit facility.
 */
export const legacyCreditFacilityPaydownRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/paydown-legacy/`, method: 'GET', signal
    },
      options);
    }
  

export const getLegacyCreditFacilityPaydownRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/paydown-legacy/`] as const;
    }

    
export const getLegacyCreditFacilityPaydownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLegacyCreditFacilityPaydownRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>> = ({ signal }) => legacyCreditFacilityPaydownRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type LegacyCreditFacilityPaydownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>>
export type LegacyCreditFacilityPaydownRetrieveQueryError = unknown

export const useLegacyCreditFacilityPaydownRetrieve = <TData = Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLegacyCreditFacilityPaydownRetrieveQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLegacyCreditFacilityPaydownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLegacyCreditFacilityPaydownRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>> = ({ signal }) => legacyCreditFacilityPaydownRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type LegacyCreditFacilityPaydownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>>
export type LegacyCreditFacilityPaydownRetrieveSuspenseQueryError = unknown

export const useLegacyCreditFacilityPaydownRetrieveSuspense = <TData = Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof legacyCreditFacilityPaydownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLegacyCreditFacilityPaydownRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getLegacyCreditFacilityPaydownRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getLegacyCreditFacilityPaydownRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId),
              queryFn: () => legacyCreditFacilityPaydownRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a credit facility paydown.
 */
export const creditFacilityLegacyPaydownCreate = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    creditFacilityPaydownUpsertDataRequest: CreditFacilityPaydownUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/paydown-legacy/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityPaydownUpsertDataRequest
    },
      options);
    }
  


export const getCreditFacilityLegacyPaydownCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLegacyPaydownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLegacyPaydownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityLegacyPaydownCreate>>, {fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownUpsertDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,fundFamilyEventId,data} = props ?? {};

          return  creditFacilityLegacyPaydownCreate(fundFamilyId,creditFacilityId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityLegacyPaydownCreateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLegacyPaydownCreate>>>
    export type CreditFacilityLegacyPaydownCreateMutationBody = CreditFacilityPaydownUpsertDataRequest
    export type CreditFacilityLegacyPaydownCreateMutationError = unknown

    export const useCreditFacilityLegacyPaydownCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLegacyPaydownCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityLegacyPaydownCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * API dedicated to getting tranche level breakdown of a use level paydown amount
 */
export const creditFacilityPaydownTrancheBreakdownTableRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    creditFacilityPaydownTrancheDetailsDataRequest: CreditFacilityPaydownTrancheDetailsDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/paydown/tranches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityPaydownTrancheDetailsDataRequest
    },
      options);
    }
  


export const getCreditFacilityPaydownTrancheBreakdownTableRetrieveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityPaydownTrancheBreakdownTableRetrieve>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownTrancheDetailsDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityPaydownTrancheBreakdownTableRetrieve>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownTrancheDetailsDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityPaydownTrancheBreakdownTableRetrieve>>, {fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownTrancheDetailsDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,fundFamilyEventId,data} = props ?? {};

          return  creditFacilityPaydownTrancheBreakdownTableRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityPaydownTrancheBreakdownTableRetrieveMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityPaydownTrancheBreakdownTableRetrieve>>>
    export type CreditFacilityPaydownTrancheBreakdownTableRetrieveMutationBody = CreditFacilityPaydownTrancheDetailsDataRequest
    export type CreditFacilityPaydownTrancheBreakdownTableRetrieveMutationError = unknown

    export const useCreditFacilityPaydownTrancheBreakdownTableRetrieve = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityPaydownTrancheBreakdownTableRetrieve>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPaydownTrancheDetailsDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityPaydownTrancheBreakdownTableRetrieveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get data for the reallocation split table
 */
export const creditFacilityReallocationDataRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    params?: CreditFacilityReallocationDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityReallocationReadData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/reallocation`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityReallocationDataRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    params?: CreditFacilityReallocationDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/reallocation`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityReallocationDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    params?: CreditFacilityReallocationDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityReallocationDataRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>> = ({ signal }) => creditFacilityReallocationDataRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityReallocationDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>>
export type CreditFacilityReallocationDataRetrieveQueryError = unknown

export const useCreditFacilityReallocationDataRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    params?: CreditFacilityReallocationDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityReallocationDataRetrieveQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityReallocationDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    params?: CreditFacilityReallocationDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityReallocationDataRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>> = ({ signal }) => creditFacilityReallocationDataRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityReallocationDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>>
export type CreditFacilityReallocationDataRetrieveSuspenseQueryError = unknown

export const useCreditFacilityReallocationDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    params?: CreditFacilityReallocationDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityReallocationDataRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityReallocationDataRetrieveLoader = (queryParamsOrFn?: (CreditFacilityReallocationDataRetrieveParams | ((params: Params) => CreditFacilityReallocationDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityReallocationDataRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId, queryParams),
              queryFn: () => creditFacilityReallocationDataRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get data for the reallocation split table
 */
export const creditFacilityReallocationCreate = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
    creditFacilityPrincipalUseReallocationDataRequest: CreditFacilityPrincipalUseReallocationDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityReallocationResponseData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/reallocation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityPrincipalUseReallocationDataRequest
    },
      options);
    }
  


export const getCreditFacilityReallocationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityReallocationCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPrincipalUseReallocationDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityReallocationCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPrincipalUseReallocationDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityReallocationCreate>>, {fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPrincipalUseReallocationDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,fundFamilyEventId,data} = props ?? {};

          return  creditFacilityReallocationCreate(fundFamilyId,creditFacilityId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityReallocationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityReallocationCreate>>>
    export type CreditFacilityReallocationCreateMutationBody = CreditFacilityPrincipalUseReallocationDataRequest
    export type CreditFacilityReallocationCreateMutationError = unknown

    export const useCreditFacilityReallocationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityReallocationCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;fundFamilyEventId: string;data: CreditFacilityPrincipalUseReallocationDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityReallocationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get credit facility principal uses for reallocation
 */
export const creditFacilityReallocationPrincipalTranchesRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/reallocation/select-tranches`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityReallocationPrincipalTranchesRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/reallocation/select-tranches`] as const;
    }

    
export const getCreditFacilityReallocationPrincipalTranchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityReallocationPrincipalTranchesRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>> = ({ signal }) => creditFacilityReallocationPrincipalTranchesRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityReallocationPrincipalTranchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>>
export type CreditFacilityReallocationPrincipalTranchesRetrieveQueryError = unknown

export const useCreditFacilityReallocationPrincipalTranchesRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityReallocationPrincipalTranchesRetrieveQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityReallocationPrincipalTranchesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityReallocationPrincipalTranchesRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>> = ({ signal }) => creditFacilityReallocationPrincipalTranchesRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityReallocationPrincipalTranchesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>>
export type CreditFacilityReallocationPrincipalTranchesRetrieveSuspenseQueryError = unknown

export const useCreditFacilityReallocationPrincipalTranchesRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationPrincipalTranchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityReallocationPrincipalTranchesRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityReallocationPrincipalTranchesRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityReallocationPrincipalTranchesRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId),
              queryFn: () => creditFacilityReallocationPrincipalTranchesRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get credit facility reallocation summary table
 */
export const creditFacilityReallocationSummaryRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/reallocation/summary`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityReallocationSummaryRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/reallocation/summary`] as const;
    }

    
export const getCreditFacilityReallocationSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityReallocationSummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>> = ({ signal }) => creditFacilityReallocationSummaryRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityReallocationSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>>
export type CreditFacilityReallocationSummaryRetrieveQueryError = unknown

export const useCreditFacilityReallocationSummaryRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityReallocationSummaryRetrieveQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityReallocationSummaryRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityReallocationSummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>> = ({ signal }) => creditFacilityReallocationSummaryRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityReallocationSummaryRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>>
export type CreditFacilityReallocationSummaryRetrieveSuspenseQueryError = unknown

export const useCreditFacilityReallocationSummaryRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityReallocationSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityReallocationSummaryRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityReallocationSummaryRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityReallocationSummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId),
              queryFn: () => creditFacilityReallocationSummaryRetrieve(fundFamilyId,creditFacilityId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a list of merge tranches summary table per loan
 */
export const creditFacilityMergePrincipalTranchesSummaryTableList = (
    fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableDataList>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/summary`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityMergePrincipalTranchesSummaryTableListQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/${fundFamilyEventId}/summary`] as const;
    }

    
export const getCreditFacilityMergePrincipalTranchesSummaryTableListQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityMergePrincipalTranchesSummaryTableListQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>> = ({ signal }) => creditFacilityMergePrincipalTranchesSummaryTableList(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityMergePrincipalTranchesSummaryTableListQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>>
export type CreditFacilityMergePrincipalTranchesSummaryTableListQueryError = unknown

export const useCreditFacilityMergePrincipalTranchesSummaryTableList = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityMergePrincipalTranchesSummaryTableListQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityMergePrincipalTranchesSummaryTableListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityMergePrincipalTranchesSummaryTableListQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>> = ({ signal }) => creditFacilityMergePrincipalTranchesSummaryTableList(fundFamilyId,creditFacilityId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityMergePrincipalTranchesSummaryTableListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>>
export type CreditFacilityMergePrincipalTranchesSummaryTableListSuspenseQueryError = unknown

export const useCreditFacilityMergePrincipalTranchesSummaryTableListSuspense = <TData = Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityMergePrincipalTranchesSummaryTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityMergePrincipalTranchesSummaryTableListSuspenseQueryOptions(fundFamilyId,creditFacilityId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityMergePrincipalTranchesSummaryTableListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityMergePrincipalTranchesSummaryTableListQueryKey(fundFamilyId,creditFacilityId,fundFamilyEventId),
              queryFn: () => creditFacilityMergePrincipalTranchesSummaryTableList(fundFamilyId,creditFacilityId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Activates a credit facility.
 */
export const creditFacilityActivate = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/activate/`, method: 'PATCH'
    },
      options);
    }
  


export const getCreditFacilityActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityActivate>>, TError,{fundFamilyId: string;creditFacilityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityActivate>>, TError,{fundFamilyId: string;creditFacilityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityActivate>>, {fundFamilyId: string;creditFacilityId: string}> = (props) => {
          const {fundFamilyId,creditFacilityId} = props ?? {};

          return  creditFacilityActivate(fundFamilyId,creditFacilityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityActivateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityActivate>>>
    
    export type CreditFacilityActivateMutationError = unknown

    export const useCreditFacilityActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityActivate>>, TError,{fundFamilyId: string;creditFacilityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityActivateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get credit facility events for the historical credit facility table
 */
export const creditFacilityEventsTableDataRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/events`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityEventsTableDataRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/events`] as const;
    }

    
export const getCreditFacilityEventsTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityEventsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>> = ({ signal }) => creditFacilityEventsTableDataRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityEventsTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>>
export type CreditFacilityEventsTableDataRetrieveQueryError = unknown

export const useCreditFacilityEventsTableDataRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityEventsTableDataRetrieveQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityEventsTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityEventsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>> = ({ signal }) => creditFacilityEventsTableDataRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityEventsTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>>
export type CreditFacilityEventsTableDataRetrieveSuspenseQueryError = unknown

export const useCreditFacilityEventsTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityEventsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityEventsTableDataRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityEventsTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityEventsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId),
              queryFn: () => creditFacilityEventsTableDataRetrieve(fundFamilyId,creditFacilityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get all expense events for a given facility
 */
export const creditFacilityInterestExpenseEventsRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/events/expenses`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityInterestExpenseEventsRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/events/expenses`] as const;
    }

    
export const getCreditFacilityInterestExpenseEventsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityInterestExpenseEventsRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>> = ({ signal }) => creditFacilityInterestExpenseEventsRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityInterestExpenseEventsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>>
export type CreditFacilityInterestExpenseEventsRetrieveQueryError = unknown

export const useCreditFacilityInterestExpenseEventsRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityInterestExpenseEventsRetrieveQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityInterestExpenseEventsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityInterestExpenseEventsRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>> = ({ signal }) => creditFacilityInterestExpenseEventsRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityInterestExpenseEventsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>>
export type CreditFacilityInterestExpenseEventsRetrieveSuspenseQueryError = unknown

export const useCreditFacilityInterestExpenseEventsRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseEventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityInterestExpenseEventsRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityInterestExpenseEventsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityInterestExpenseEventsRetrieveQueryKey(fundFamilyId,creditFacilityId),
              queryFn: () => creditFacilityInterestExpenseEventsRetrieve(fundFamilyId,creditFacilityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the interest expense table for a given loan for adjustments
 */
export const creditFacilityInterestExpenseAdjustmentsTableRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    params?: CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityExpenseAdjustments>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/expenses/${expenseEventId}/adjustment`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    params?: CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/expenses/${expenseEventId}/adjustment`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    params?: CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>> = ({ signal }) => creditFacilityInterestExpenseAdjustmentsTableRetrieve(fundFamilyId,creditFacilityId,expenseEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && expenseEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>>
export type CreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryError = unknown

export const useCreditFacilityInterestExpenseAdjustmentsTableRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    params?: CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryOptions(fundFamilyId,creditFacilityId,expenseEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityInterestExpenseAdjustmentsTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    params?: CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>> = ({ signal }) => creditFacilityInterestExpenseAdjustmentsTableRetrieve(fundFamilyId,creditFacilityId,expenseEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && expenseEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityInterestExpenseAdjustmentsTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>>
export type CreditFacilityInterestExpenseAdjustmentsTableRetrieveSuspenseQueryError = unknown

export const useCreditFacilityInterestExpenseAdjustmentsTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    params?: CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseAdjustmentsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityInterestExpenseAdjustmentsTableRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,expenseEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityInterestExpenseAdjustmentsTableRetrieveLoader = (queryParamsOrFn?: (CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams | ((params: Params) => CreditFacilityInterestExpenseAdjustmentsTableRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,expenseEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,expenseEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId && expenseEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityInterestExpenseAdjustmentsTableRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId, queryParams),
              queryFn: () => creditFacilityInterestExpenseAdjustmentsTableRetrieve(fundFamilyId,creditFacilityId,expenseEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Post the interest expense adjustments for a given loan
 */
export const creditFacilityInterestExpensesAdjust = (
    fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    creditFacilityExpenseAdjustmentsUpdateDataRequest: CreditFacilityExpenseAdjustmentsUpdateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/expenses/${expenseEventId}/adjustment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityExpenseAdjustmentsUpdateDataRequest
    },
      options);
    }
  


export const getCreditFacilityInterestExpensesAdjustMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpensesAdjust>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseAdjustmentsUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpensesAdjust>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseAdjustmentsUpdateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityInterestExpensesAdjust>>, {fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseAdjustmentsUpdateDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,expenseEventId,data} = props ?? {};

          return  creditFacilityInterestExpensesAdjust(fundFamilyId,creditFacilityId,expenseEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityInterestExpensesAdjustMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpensesAdjust>>>
    export type CreditFacilityInterestExpensesAdjustMutationBody = CreditFacilityExpenseAdjustmentsUpdateDataRequest
    export type CreditFacilityInterestExpensesAdjustMutationError = unknown

    export const useCreditFacilityInterestExpensesAdjust = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpensesAdjust>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseAdjustmentsUpdateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityInterestExpensesAdjustMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get expense details for a given facility
 */
export const creditFacilityExpenseDetailsTableRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/expenses/details`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityExpenseDetailsTableRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/expenses/details`] as const;
    }

    
export const getCreditFacilityExpenseDetailsTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityExpenseDetailsTableRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>> = ({ signal }) => creditFacilityExpenseDetailsTableRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityExpenseDetailsTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>>
export type CreditFacilityExpenseDetailsTableRetrieveQueryError = unknown

export const useCreditFacilityExpenseDetailsTableRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityExpenseDetailsTableRetrieveQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityExpenseDetailsTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityExpenseDetailsTableRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>> = ({ signal }) => creditFacilityExpenseDetailsTableRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityExpenseDetailsTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>>
export type CreditFacilityExpenseDetailsTableRetrieveSuspenseQueryError = unknown

export const useCreditFacilityExpenseDetailsTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseDetailsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityExpenseDetailsTableRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityExpenseDetailsTableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityExpenseDetailsTableRetrieveQueryKey(fundFamilyId,creditFacilityId),
              queryFn: () => creditFacilityExpenseDetailsTableRetrieve(fundFamilyId,creditFacilityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the interest expense data for the event
 */
export const creditFacilityInterestExpensePost = (
    fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/expenses/post/${expenseEventId}`, method: 'POST'
    },
      options);
    }
  


export const getCreditFacilityInterestExpensePostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpensePost>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpensePost>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityInterestExpensePost>>, {fundFamilyId: string;creditFacilityId: string;expenseEventId: string}> = (props) => {
          const {fundFamilyId,creditFacilityId,expenseEventId} = props ?? {};

          return  creditFacilityInterestExpensePost(fundFamilyId,creditFacilityId,expenseEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityInterestExpensePostMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpensePost>>>
    
    export type CreditFacilityInterestExpensePostMutationError = unknown

    export const useCreditFacilityInterestExpensePost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpensePost>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityInterestExpensePostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get interest expense event
 */
export const creditFacilityExpenseEventRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityExpenseEventReadData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/${expenseEventId}`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityExpenseEventRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/${expenseEventId}`] as const;
    }

    
export const getCreditFacilityExpenseEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityExpenseEventRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>> = ({ signal }) => creditFacilityExpenseEventRetrieve(fundFamilyId,creditFacilityId,expenseEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && expenseEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityExpenseEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>>
export type CreditFacilityExpenseEventRetrieveQueryError = unknown

export const useCreditFacilityExpenseEventRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityExpenseEventRetrieveQueryOptions(fundFamilyId,creditFacilityId,expenseEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityExpenseEventRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityExpenseEventRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>> = ({ signal }) => creditFacilityExpenseEventRetrieve(fundFamilyId,creditFacilityId,expenseEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && expenseEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityExpenseEventRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>>
export type CreditFacilityExpenseEventRetrieveSuspenseQueryError = unknown

export const useCreditFacilityExpenseEventRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityExpenseEventRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,expenseEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityExpenseEventRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,expenseEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,expenseEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && expenseEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityExpenseEventRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId),
              queryFn: () => creditFacilityExpenseEventRetrieve(fundFamilyId,creditFacilityId,expenseEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Generates interest expenses for a given expense event
 */
export const creditFacilityInterestExpenseCreate = (
    fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
    creditFacilityExpenseEventUpsertDataRequest: CreditFacilityExpenseEventUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/${expenseEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityExpenseEventUpsertDataRequest
    },
      options);
    }
  


export const getCreditFacilityInterestExpenseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseEventUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseEventUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityInterestExpenseCreate>>, {fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseEventUpsertDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,expenseEventId,data} = props ?? {};

          return  creditFacilityInterestExpenseCreate(fundFamilyId,creditFacilityId,expenseEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityInterestExpenseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpenseCreate>>>
    export type CreditFacilityInterestExpenseCreateMutationBody = CreditFacilityExpenseEventUpsertDataRequest
    export type CreditFacilityInterestExpenseCreateMutationError = unknown

    export const useCreditFacilityInterestExpenseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;expenseEventId: string;data: CreditFacilityExpenseEventUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityInterestExpenseCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get the interest expense summary for the event.
 */
export const creditFacilityInterestExpenseSummaryRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityExpenseSummaryData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/${expenseEventId}/summary`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityInterestExpenseSummaryRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/${expenseEventId}/summary`] as const;
    }

    
export const getCreditFacilityInterestExpenseSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityInterestExpenseSummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>> = ({ signal }) => creditFacilityInterestExpenseSummaryRetrieve(fundFamilyId,creditFacilityId,expenseEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && expenseEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityInterestExpenseSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>>
export type CreditFacilityInterestExpenseSummaryRetrieveQueryError = unknown

export const useCreditFacilityInterestExpenseSummaryRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityInterestExpenseSummaryRetrieveQueryOptions(fundFamilyId,creditFacilityId,expenseEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityInterestExpenseSummaryRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityInterestExpenseSummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>> = ({ signal }) => creditFacilityInterestExpenseSummaryRetrieve(fundFamilyId,creditFacilityId,expenseEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && expenseEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityInterestExpenseSummaryRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>>
export type CreditFacilityInterestExpenseSummaryRetrieveSuspenseQueryError = unknown

export const useCreditFacilityInterestExpenseSummaryRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    expenseEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityInterestExpenseSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityInterestExpenseSummaryRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,expenseEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityInterestExpenseSummaryRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,expenseEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,expenseEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && expenseEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityInterestExpenseSummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,expenseEventId),
              queryFn: () => creditFacilityInterestExpenseSummaryRetrieve(fundFamilyId,creditFacilityId,expenseEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * List credit facility tranches
 */
export const creditFacilityAvailableTranchesForExpensePostingList = (
    fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityTranchesAvailableForPostingList>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/loan/${loanId}/available-tranches/`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityAvailableTranchesForExpensePostingListQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/loan/${loanId}/available-tranches/`] as const;
    }

    
export const getCreditFacilityAvailableTranchesForExpensePostingListQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityAvailableTranchesForExpensePostingListQueryKey(fundFamilyId,creditFacilityId,loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>> = ({ signal }) => creditFacilityAvailableTranchesForExpensePostingList(fundFamilyId,creditFacilityId,loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityAvailableTranchesForExpensePostingListQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>>
export type CreditFacilityAvailableTranchesForExpensePostingListQueryError = unknown

export const useCreditFacilityAvailableTranchesForExpensePostingList = <TData = Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityAvailableTranchesForExpensePostingListQueryOptions(fundFamilyId,creditFacilityId,loanId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityAvailableTranchesForExpensePostingListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityAvailableTranchesForExpensePostingListQueryKey(fundFamilyId,creditFacilityId,loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>> = ({ signal }) => creditFacilityAvailableTranchesForExpensePostingList(fundFamilyId,creditFacilityId,loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityAvailableTranchesForExpensePostingListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>>
export type CreditFacilityAvailableTranchesForExpensePostingListSuspenseQueryError = unknown

export const useCreditFacilityAvailableTranchesForExpensePostingListSuspense = <TData = Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityAvailableTranchesForExpensePostingList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityAvailableTranchesForExpensePostingListSuspenseQueryOptions(fundFamilyId,creditFacilityId,loanId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityAvailableTranchesForExpensePostingListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,loanId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,loanId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && loanId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityAvailableTranchesForExpensePostingListQueryKey(fundFamilyId,creditFacilityId,loanId),
              queryFn: () => creditFacilityAvailableTranchesForExpensePostingList(fundFamilyId,creditFacilityId,loanId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets an interest expense period based on optional parameters
 */
export const creditFacilityExpenseEventPeriodRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityExpenseEventPeriodRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<InterestExpensePeriodData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/loan/${loanId}/period`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityExpenseEventPeriodRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityExpenseEventPeriodRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/interest-expenses/loan/${loanId}/period`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityExpenseEventPeriodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityExpenseEventPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityExpenseEventPeriodRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>> = ({ signal }) => creditFacilityExpenseEventPeriodRetrieve(fundFamilyId,creditFacilityId,loanId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityExpenseEventPeriodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>>
export type CreditFacilityExpenseEventPeriodRetrieveQueryError = unknown

export const useCreditFacilityExpenseEventPeriodRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityExpenseEventPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityExpenseEventPeriodRetrieveQueryOptions(fundFamilyId,creditFacilityId,loanId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityExpenseEventPeriodRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityExpenseEventPeriodRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityExpenseEventPeriodRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>> = ({ signal }) => creditFacilityExpenseEventPeriodRetrieve(fundFamilyId,creditFacilityId,loanId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityExpenseEventPeriodRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>>
export type CreditFacilityExpenseEventPeriodRetrieveSuspenseQueryError = unknown

export const useCreditFacilityExpenseEventPeriodRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityExpenseEventPeriodRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityExpenseEventPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityExpenseEventPeriodRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,loanId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityExpenseEventPeriodRetrieveLoader = (queryParamsOrFn?: (CreditFacilityExpenseEventPeriodRetrieveParams | ((params: Params) => CreditFacilityExpenseEventPeriodRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,loanId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,loanId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId && loanId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityExpenseEventPeriodRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId, queryParams),
              queryFn: () => creditFacilityExpenseEventPeriodRetrieve(fundFamilyId,creditFacilityId,loanId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * gets a credit facility loan
 */
export const creditFacilityLoanRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityLoanData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/loan/${loanId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityLoanRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/loan/${loanId}/`] as const;
    }

    
export const getCreditFacilityLoanRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>> = ({ signal }) => creditFacilityLoanRetrieve(fundFamilyId,creditFacilityId,loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>>
export type CreditFacilityLoanRetrieveQueryError = unknown

export const useCreditFacilityLoanRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanRetrieveQueryOptions(fundFamilyId,creditFacilityId,loanId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityLoanRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>> = ({ signal }) => creditFacilityLoanRetrieve(fundFamilyId,creditFacilityId,loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>>
export type CreditFacilityLoanRetrieveSuspenseQueryError = unknown

export const useCreditFacilityLoanRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,loanId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityLoanRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,loanId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,loanId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && loanId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityLoanRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId),
              queryFn: () => creditFacilityLoanRetrieve(fundFamilyId,creditFacilityId,loanId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Edits credit facility loan
 */
export const creditFacilityLoanEdit = (
    fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    creditFacilityLoanEditAPIDataRequest: CreditFacilityLoanEditAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityLoanData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/loan/${loanId}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityLoanEditAPIDataRequest
    },
      options);
    }
  


export const getCreditFacilityLoanEditMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLoanEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;loanId: string;data: CreditFacilityLoanEditAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLoanEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;loanId: string;data: CreditFacilityLoanEditAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityLoanEdit>>, {fundFamilyId: string;creditFacilityId: string;loanId: string;data: CreditFacilityLoanEditAPIDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,loanId,data} = props ?? {};

          return  creditFacilityLoanEdit(fundFamilyId,creditFacilityId,loanId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityLoanEditMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanEdit>>>
    export type CreditFacilityLoanEditMutationBody = CreditFacilityLoanEditAPIDataRequest
    export type CreditFacilityLoanEditMutationError = unknown

    export const useCreditFacilityLoanEdit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLoanEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;loanId: string;data: CreditFacilityLoanEditAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityLoanEditMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * gets a credit facility loan
 */
export const creditFacilityLoanVersionRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityLoanVersionRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityLoanVersionReadData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/loan/${loanId}/versions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityLoanVersionRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityLoanVersionRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/loan/${loanId}/versions`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityLoanVersionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityLoanVersionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>> = ({ signal }) => creditFacilityLoanVersionRetrieve(fundFamilyId,creditFacilityId,loanId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanVersionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>>
export type CreditFacilityLoanVersionRetrieveQueryError = unknown

export const useCreditFacilityLoanVersionRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityLoanVersionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanVersionRetrieveQueryOptions(fundFamilyId,creditFacilityId,loanId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityLoanVersionRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityLoanVersionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>> = ({ signal }) => creditFacilityLoanVersionRetrieve(fundFamilyId,creditFacilityId,loanId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanVersionRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>>
export type CreditFacilityLoanVersionRetrieveSuspenseQueryError = unknown

export const useCreditFacilityLoanVersionRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
    params?: CreditFacilityLoanVersionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanVersionRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,loanId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityLoanVersionRetrieveLoader = (queryParamsOrFn?: (CreditFacilityLoanVersionRetrieveParams | ((params: Params) => CreditFacilityLoanVersionRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,loanId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,loanId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId && loanId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityLoanVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId, queryParams),
              queryFn: () => creditFacilityLoanVersionRetrieve(fundFamilyId,creditFacilityId,loanId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * creates a single credit facility loan
 */
export const creditFacilityLoanCreate = (
    fundFamilyId: string,
    creditFacilityId: string,
    creditFacilityLoanCreateDataRequest: CreditFacilityLoanCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityLoanData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/loan/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityLoanCreateDataRequest
    },
      options);
    }
  


export const getCreditFacilityLoanCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLoanCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityLoanCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLoanCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityLoanCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityLoanCreate>>, {fundFamilyId: string;creditFacilityId: string;data: CreditFacilityLoanCreateDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,data} = props ?? {};

          return  creditFacilityLoanCreate(fundFamilyId,creditFacilityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityLoanCreateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanCreate>>>
    export type CreditFacilityLoanCreateMutationBody = CreditFacilityLoanCreateDataRequest
    export type CreditFacilityLoanCreateMutationError = unknown

    export const useCreditFacilityLoanCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityLoanCreate>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityLoanCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityLoanCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get the table of loan settings for the settings page
 */
export const creditFacilityLoanSettingsTableDataRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/setings/loans`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityLoanSettingsTableDataRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/setings/loans`] as const;
    }

    
export const getCreditFacilityLoanSettingsTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanSettingsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>> = ({ signal }) => creditFacilityLoanSettingsTableDataRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanSettingsTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>>
export type CreditFacilityLoanSettingsTableDataRetrieveQueryError = unknown

export const useCreditFacilityLoanSettingsTableDataRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanSettingsTableDataRetrieveQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityLoanSettingsTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanSettingsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>> = ({ signal }) => creditFacilityLoanSettingsTableDataRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanSettingsTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>>
export type CreditFacilityLoanSettingsTableDataRetrieveSuspenseQueryError = unknown

export const useCreditFacilityLoanSettingsTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanSettingsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanSettingsTableDataRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityLoanSettingsTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityLoanSettingsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId),
              queryFn: () => creditFacilityLoanSettingsTableDataRetrieve(fundFamilyId,creditFacilityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the table of loan versions for a given loan
 */
export const creditFacilityLoanVersionsTableDataRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/setings/loans/${loanId}/versions`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityLoanVersionsTableDataRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    loanId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/setings/loans/${loanId}/versions`] as const;
    }

    
export const getCreditFacilityLoanVersionsTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanVersionsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>> = ({ signal }) => creditFacilityLoanVersionsTableDataRetrieve(fundFamilyId,creditFacilityId,loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanVersionsTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>>
export type CreditFacilityLoanVersionsTableDataRetrieveQueryError = unknown

export const useCreditFacilityLoanVersionsTableDataRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanVersionsTableDataRetrieveQueryOptions(fundFamilyId,creditFacilityId,loanId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityLoanVersionsTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityLoanVersionsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>> = ({ signal }) => creditFacilityLoanVersionsTableDataRetrieve(fundFamilyId,creditFacilityId,loanId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && loanId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityLoanVersionsTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>>
export type CreditFacilityLoanVersionsTableDataRetrieveSuspenseQueryError = unknown

export const useCreditFacilityLoanVersionsTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    loanId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityLoanVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityLoanVersionsTableDataRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,loanId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityLoanVersionsTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,loanId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,loanId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId && loanId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityLoanVersionsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId,loanId),
              queryFn: () => creditFacilityLoanVersionsTableDataRetrieve(fundFamilyId,creditFacilityId,loanId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the table of versions for the settings page
 */
export const creditFacilityVersionsTableDataRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/settings/versions`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilityVersionsTableDataRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/settings/versions`] as const;
    }

    
export const getCreditFacilityVersionsTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityVersionsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>> = ({ signal }) => creditFacilityVersionsTableDataRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityVersionsTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>>
export type CreditFacilityVersionsTableDataRetrieveQueryError = unknown

export const useCreditFacilityVersionsTableDataRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityVersionsTableDataRetrieveQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityVersionsTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityVersionsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>> = ({ signal }) => creditFacilityVersionsTableDataRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityVersionsTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>>
export type CreditFacilityVersionsTableDataRetrieveSuspenseQueryError = unknown

export const useCreditFacilityVersionsTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionsTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityVersionsTableDataRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityVersionsTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityVersionsTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId),
              queryFn: () => creditFacilityVersionsTableDataRetrieve(fundFamilyId,creditFacilityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets credit facility summary information
 */
export const creditFacilitySummaryRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilitySummaryRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityPrincipalSummaryData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/summary/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilitySummaryRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilitySummaryRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/summary/`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilitySummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilitySummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilitySummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>> = ({ signal }) => creditFacilitySummaryRetrieve(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilitySummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>>
export type CreditFacilitySummaryRetrieveQueryError = unknown

export const useCreditFacilitySummaryRetrieve = <TData = Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilitySummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilitySummaryRetrieveQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilitySummaryRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilitySummaryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilitySummaryRetrieveQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>> = ({ signal }) => creditFacilitySummaryRetrieve(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilitySummaryRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>>
export type CreditFacilitySummaryRetrieveSuspenseQueryError = unknown

export const useCreditFacilitySummaryRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilitySummaryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilitySummaryRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilitySummaryRetrieveLoader = (queryParamsOrFn?: (CreditFacilitySummaryRetrieveParams | ((params: Params) => CreditFacilitySummaryRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilitySummaryRetrieveQueryKey(fundFamilyId,creditFacilityId, queryParams),
              queryFn: () => creditFacilitySummaryRetrieve(fundFamilyId,creditFacilityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets credit facility summary information in chart format
 */
export const creditFacilitySummarChartRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericChartData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/summary/chart`, method: 'GET', signal
    },
      options);
    }
  

export const getCreditFacilitySummarChartRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/summary/chart`] as const;
    }

    
export const getCreditFacilitySummarChartRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilitySummarChartRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>> = ({ signal }) => creditFacilitySummarChartRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilitySummarChartRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>>
export type CreditFacilitySummarChartRetrieveQueryError = unknown

export const useCreditFacilitySummarChartRetrieve = <TData = Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilitySummarChartRetrieveQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilitySummarChartRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilitySummarChartRetrieveQueryKey(fundFamilyId,creditFacilityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>> = ({ signal }) => creditFacilitySummarChartRetrieve(fundFamilyId,creditFacilityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilitySummarChartRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>>
export type CreditFacilitySummarChartRetrieveSuspenseQueryError = unknown

export const useCreditFacilitySummarChartRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilitySummarChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilitySummarChartRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilitySummarChartRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilitySummarChartRetrieveQueryKey(fundFamilyId,creditFacilityId),
              queryFn: () => creditFacilitySummarChartRetrieve(fundFamilyId,creditFacilityId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get credit facility principal uses
 */
export const creditFacilityPrincipalUsesRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityPrincipalUsesRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/uses/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityPrincipalUsesRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityPrincipalUsesRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/uses/`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityPrincipalUsesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityPrincipalUsesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityPrincipalUsesRetrieveQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>> = ({ signal }) => creditFacilityPrincipalUsesRetrieve(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityPrincipalUsesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>>
export type CreditFacilityPrincipalUsesRetrieveQueryError = unknown

export const useCreditFacilityPrincipalUsesRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityPrincipalUsesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityPrincipalUsesRetrieveQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityPrincipalUsesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityPrincipalUsesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityPrincipalUsesRetrieveQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>> = ({ signal }) => creditFacilityPrincipalUsesRetrieve(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityPrincipalUsesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>>
export type CreditFacilityPrincipalUsesRetrieveSuspenseQueryError = unknown

export const useCreditFacilityPrincipalUsesRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityPrincipalUsesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityPrincipalUsesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityPrincipalUsesRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityPrincipalUsesRetrieveLoader = (queryParamsOrFn?: (CreditFacilityPrincipalUsesRetrieveParams | ((params: Params) => CreditFacilityPrincipalUsesRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityPrincipalUsesRetrieveQueryKey(fundFamilyId,creditFacilityId, queryParams),
              queryFn: () => creditFacilityPrincipalUsesRetrieve(fundFamilyId,creditFacilityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a credit facility version by credit facility id and optional date
 */
export const creditFacilityVersionRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityVersionRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityVersionData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/versions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityVersionRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityVersionRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility/${creditFacilityId}/versions`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityVersionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityVersionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>> = ({ signal }) => creditFacilityVersionRetrieve(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityVersionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>>
export type CreditFacilityVersionRetrieveQueryError = unknown

export const useCreditFacilityVersionRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityVersionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityVersionRetrieveQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityVersionRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityVersionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>> = ({ signal }) => creditFacilityVersionRetrieve(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityVersionRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>>
export type CreditFacilityVersionRetrieveSuspenseQueryError = unknown

export const useCreditFacilityVersionRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityVersionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityVersionRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityVersionRetrieveLoader = (queryParamsOrFn?: (CreditFacilityVersionRetrieveParams | ((params: Params) => CreditFacilityVersionRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityVersionRetrieveQueryKey(fundFamilyId,creditFacilityId, queryParams),
              queryFn: () => creditFacilityVersionRetrieve(fundFamilyId,creditFacilityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts a credit facility version
 */
export const creditFacilityVersionUpsert = (
    fundFamilyId: string,
    creditFacilityVersionUpsertDataRequest: CreditFacilityVersionUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility/versions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityVersionUpsertDataRequest
    },
      options);
    }
  


export const getCreditFacilityVersionUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityVersionUpsert>>, TError,{fundFamilyId: string;data: CreditFacilityVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityVersionUpsert>>, TError,{fundFamilyId: string;data: CreditFacilityVersionUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityVersionUpsert>>, {fundFamilyId: string;data: CreditFacilityVersionUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  creditFacilityVersionUpsert(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityVersionUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityVersionUpsert>>>
    export type CreditFacilityVersionUpsertMutationBody = CreditFacilityVersionUpsertDataRequest
    export type CreditFacilityVersionUpsertMutationError = unknown

    export const useCreditFacilityVersionUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityVersionUpsert>>, TError,{fundFamilyId: string;data: CreditFacilityVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityVersionUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    